import React from 'react'
import {Link} from 'react-router-dom'
import Swipeable from 'react-swipeable'

class HeroCarousel extends React.Component {




  constructor(){
    super()

    this.state = {
      activeSlide:0,
      prevSlide:-1,
      autoplay: true,
      autoPlayTimeout: ''
    }

    this.gotoSlide = this.gotoSlide.bind(this)
    this.clickGotoSlide = this.clickGotoSlide.bind(this)
    this.autoPlayNextSlide = this.autoPlayNextSlide.bind(this)

    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)

    this.autoPlayDelay = 3000


  }


  componentWillMount(){


      if(this.state.autoplay){
        this.setState({'autoPlayTimeout':setTimeout(this.autoPlayNextSlide, this.autoPlayDelay)});
      }
  }

  componentWillUnmount(){
    clearTimeout(this.state.autoPlayTimeout)
  }

  autoPlayNextSlide(){
      if(this.state.autoplay){
          let next = (this.state.activeSlide+1 > this.props.slides.length-1)? 0 : this.state.activeSlide+1 ;
          this.gotoSlide(next)
          this.setState({'autoPlayTimeout':setTimeout(this.autoPlayNextSlide, this.autoPlayDelay)});
      }
  }






  addSlide(item,i){


      let activeClass = (i===this.state.activeSlide)? 'active' : ''
      let prevClass = (i===this.state.prevSlide)? 'prev' : ''
      let slideClass = 'slide '+prevClass+' '+activeClass;

      return (
        <div className={slideClass} key={'heroslide'+i} >
          <Link to={'/project/'+item.slug}>
            <div className="image" style={{backgroundImage:'url('+item.image+')'}}></div>
            <div className="title">
              <h1 dangerouslySetInnerHTML={{__html:item.title}}></h1>
            </div>
          </Link>
        </div>
      )
  }



  addIndicator(item,i){


    let indicatorClass = (i===this.state.activeSlide)? 'active' : ''

    return (
      <div className={'outer '+indicatorClass} key={'heroslide'+i} onClick={()=>{this.clickGotoSlide(i)}}><div className="inner"></div></div>
      )


  }

  clickGotoSlide(num){
    this.setState({autoplay:false})
    this.gotoSlide(num)
  }

  gotoSlide(num){
    let activeSlide = num
    let prevSlide  = this.state.activeSlide

    this.setState({prevSlide,activeSlide})
  }

  nextSlide(){
    clearTimeout(this.state.autoPlayTimeout)
      let next = (this.state.activeSlide + 1 >this.props.slides.length-1)? 0 : this.state.activeSlide + 1;
      this.gotoSlide(next)
  }

  prevSlide(){
    clearTimeout(this.state.autoPlayTimeout)
    let prev = (this.state.activeSlide -1 < 0)? this.props.slides.length-1: this.state.activeSlide - 1;
    this.gotoSlide(prev)
  }

  render () {

    let slides = this.props.slides


    return(

        <Swipeable className="hero-carousel" onSwipedLeft={this.nextSlide} onSwipedRight={this.prevSlide}>
          <div className="slides">
          {
            slides.map((item,i)=>{
              return this.addSlide(item,i)
            })
          }
          </div>
          <div className="controls">
          {
            slides.map((item,i)=>{
              return this.addIndicator(item,i)
            })
          }
          </div>
        </Swipeable>

    )
  }
}

export default HeroCarousel;



// WEBPACK FOOTER //
// ./src/modules/hero/HeroCarousel.js